import * as React from 'react';
import { translate } from 'react-i18next';
import { navigationPromptFactory } from 'common/components/core/router';
import { confirmationDialogFactory } from 'common/components/core/dialog/ConfirmationDialog';
import theme from './ZoneMapSaveDialog.scss';
import Button, { ButtonTypes } from 'common/components/core/button';
import { dashboardColors } from 'common/enums/ColorEnum';
import Input from 'common/components/core/input';

const SaveDialogOptions = ({
    t,
    mapName,
    rejectOptionLabel,
    acceptOptionLabel,
    onCancel,
    onSave,
    onConfirm,
    isMapLoading,
    theme
}) => {
    const rejectAction = mapName ? onConfirm : onCancel;
    return (
        <div className={theme.dialogActions}>
            {!mapName ? (
                <Button
                    onClick={onConfirm}
                    className={theme.deleteBtn}
                    icon="delete-bin"
                    label={t('zoneMap.delete')}
                    theme={theme}
                    ripple={false}
                    semibold
                />
            ) : null}
            <Button
                className={theme.cancelBtn}
                buttonType={ButtonTypes.Text}
                label={rejectOptionLabel}
                onClick={rejectAction}
                theme={theme}
            />
            <Button
                label={acceptOptionLabel}
                className={theme.saveBtn}
                buttonType={ButtonTypes.Text}
                onClick={onSave}
                isLoading={isMapLoading}
                color={dashboardColors.darkSkyBlue.name}
                theme={theme}
            />
        </div>
    );
};

const SaveDialogContent = ({
    innerText,
    name,
    mapName,
    handleMapNameSave,
    t
}) => (
    <div className={theme.dialogContent}>
        <span className={theme.content}> {innerText}</span>
        {!mapName ? (
            <Input
                label={t('zoneMap.mapName')}
                className={theme.nameInput}
                theme={theme}
                value={name}
                onChange={handleMapNameSave}
                clearableInput
                placeholder={t('zoneMap.untitledMap')}
            />
        ) : null}
    </div>
);

const ZoneMapSaveDialogInner = confirmationDialogFactory({
    InnerContent: translate('entityManagement')(SaveDialogContent),
    Actions: translate('entityManagement')(SaveDialogOptions)
});

class ZoneMapSaveDialog extends React.PureComponent {
    state = {
        mapNameToBeSaved: ''
    };

    onSave = () => {
        const { onSave, onConfirm } = this.props;
        onSave(this.state.mapNameToBeSaved, { onSuccess: onConfirm });
    };
    saveName = name => this.setState({ mapNameToBeSaved: name });
    render() {
        const {
            t,
            mapName,
            isOpen,
            onCancel,
            onConfirm,
            isMapLoading
        } = this.props;
        const { mapNameToBeSaved } = this.state;
        const innerText = t(
            mapName ? 'zoneMap.navigateAwayPrompt' : 'zoneMap.unsavedChanges'
        );
        const rejectOptionLabel = mapName
            ? t('zoneMap.dontSave')
            : t('zoneMap.cancel');
        return (
            <ZoneMapSaveDialogInner
                t={t}
                theme={theme}
                mapName={mapName}
                name={mapNameToBeSaved}
                active={isOpen}
                title={t('zoneMap.keepChanges')}
                innerText={innerText}
                className={theme.saveDialogWrap}
                onConfirm={onConfirm}
                onCancel={onCancel}
                onSave={this.onSave}
                isMapLoading={isMapLoading}
                rejectOptionLabel={rejectOptionLabel}
                acceptOptionLabel={t('zoneMap.save')}
                handleMapNameSave={this.saveName}
            />
        );
    }
}

const NavigationPrompt = navigationPromptFactory({
    Prompt: ZoneMapSaveDialog
});
export default translate('entityManagement')(NavigationPrompt);
